import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FilterableTable, Loader, Button, __deprecated_StatelessSearchDropdown } from '../components/common';
import { dictionary } from '../lang';
import { getAreaList, getTeams, selectAreaList, selectTeams } from '../redux';
import { urlTo } from '../utils';
const columns = [
    {
        align: 'right',
        width: 32,
        text: dictionary.TEAM_CODE,
        sortable: true,
        id: 'team_id',
    },
    {
        align: 'left',
        text: dictionary.TEAM_NAME,
        sortable: true,
        id: 'team_name',
    },
    {
        align: 'right',
        text: dictionary.AREA_ID,
        sortable: true,
        id: 'area_id',
    },
    {
        align: 'left',
        text: dictionary.AREA_NAME,
        sortable: true,
        id: 'area_name',
    },
    {
        align: 'right',
        text: dictionary.TOTAL_REPS,
        sortable: true,
        id: 'total_reps',
    },
    {
        align: 'right',
        text: dictionary.ACTIVE,
        sortable: true,
        id: 'active_customers',
    },
    {
        align: 'right',
        text: dictionary.INACTIVE,
        sortable: true,
        id: 'inactive_customers',
    },
    {
        align: 'right',
        text: dictionary.QUALIFIED_ADDRESSES,
        sortable: true,
        id: 'qualified_addresses',
    },
    {
        align: 'left',
        width: 24,
        text: '',
        sortable: false,
        id: 'view_map',
    },
    {
        align: 'left',
        width: 24,
        text: '',
        sortable: false,
        id: 'view_polygons',
    },
];
const TeamsTable = () => {
    const [areaId, setAreaId] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [selectedPage, setSelectedPage] = useState(1);
    const [selection, setSelection] = useState(null);
    const [sortParams, setSortParams] = useState({ name: 'area_id', order: 'asc' });
    const dispatch = useDispatch();
    const { teams, total, isLoading } = useSelector(selectTeams);
    const { areaList, isLoading: isAreaListLoading } = useSelector(selectAreaList);
    const teamRows = useMemo(() => teams.map(({ id, name, areaId, areaName, totalReps, activeCustomers, inactiveCustomers, totalQualifiedAddresses, hasBoundary, }) => ([
        id,
        name,
        areaId,
        areaName,
        totalReps,
        activeCustomers,
        inactiveCustomers,
        totalQualifiedAddresses,
        ...(hasBoundary ? [
            _jsx(Link, { className: "text-center text-primary-300", to: urlTo('team/:teamId', { teamId: id }), children: dictionary.VIEW_MAP }, `team/${id}`),
            _jsx(Link, { className: "text-center text-primary-300", to: urlTo('team/:teamId/polygons', { teamId: id }), children: dictionary.VIEW_POLYGONS }, `team/${id}/polygons`),
        ] : [
            _jsx("span", { className: "cursor-default text-center text-disabled", children: dictionary.VIEW_MAP }, `team/${id}`),
            _jsx("span", { className: "cursor-default text-center text-disabled", children: dictionary.VIEW_POLYGONS }, `team/${id}/polygons`),
        ]),
    ])), [teams]);
    const areaOptions = useMemo(() => ([
        {
            name: dictionary.ALL_AREAS,
            value: '',
        },
        ...areaList.map(({ id: value, name, }) => ({
            name,
            value,
        })),
    ]), [areaList]);
    const onFilterClick = () => {
        setAreaId(selection.value);
        setSelectedPage(1);
    };
    const onAreaChange = (area) => {
        setSelection(area);
    };
    const updateTable = useCallback(() => {
        const params = {
            ...(areaId && { area_id: areaId }),
            ...(searchText && { search: searchText }),
            sort_by: sortParams.name,
            order: sortParams.order,
            page: selectedPage,
            limit: pageSize,
        };
        dispatch(getTeams.request(params));
    }, [
        dispatch,
        areaId,
        pageSize,
        searchText,
        selectedPage,
        sortParams,
    ]);
    useEffect(() => {
        updateTable();
    }, [updateTable]);
    useEffect(() => {
        dispatch(getAreaList.request());
    }, [dispatch]);
    const leftControl = isAreaListLoading
        ? (_jsx(Loader, {})) : (_jsx(__deprecated_StatelessSearchDropdown, { displayProp: "name", className: "w-full md:w-56", label: dictionary.FILTER_BY_AREAS, items: areaOptions, onChange: onAreaChange, selected: selection, button: _jsx(Button, { onClick: onFilterClick, children: dictionary.FILTER }) }));
    return (_jsx(FilterableTable, { leftControl: leftControl, loading: isLoading, columns: columns, rows: teamRows, pageSize: pageSize, setPageSize: setPageSize, sortParams: sortParams, onSortChange: setSortParams, onSearch: updateTable, searchPlaceholder: dictionary.SEARCH_TEAMS, searchText: searchText, setSearchText: setSearchText, selectedPage: selectedPage, setSelectedPage: setSelectedPage, totalCount: total }));
};
export default TeamsTable;
